import { publicPageHref } from '../app/publicRoutes'

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <span>Copyright © Mapapal.com 2026</span>
      <span className="site-footer__divider" aria-hidden="true" />
      <nav aria-label="Mapapal information">
        <a href={publicPageHref('about')}>About</a>
        <a href={publicPageHref('privacy')}>Privacy &amp; cookies</a>
        <a href={publicPageHref('terms')}>Terms</a>
        <a href="https://legacy.mapapal.com" target="_blank" rel="noopener noreferrer">Legacy web</a>
      </nav>
      <span className="site-footer__divider" aria-hidden="true" />
      <a href="mailto:support@mapapal.com">Contact</a>
    </footer>
  )
}
